/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

 function isElementVisible(el) {
    var rect     = el.getBoundingClientRect(),
        vWidth   = window.innerWidth || document.documentElement.clientWidth,
        vHeight  = window.innerHeight || document.documentElement.clientHeight,
        efp      = function (x, y) { return document.elementFromPoint(x, y) };     

    // Return false if it's not in the viewport
    if (rect.right < 0 || rect.bottom < 0 
            || rect.left > vWidth || rect.top > vHeight)
        return false;

    // Return true if any of its four corners are visible
    return (
          el.contains(efp(rect.left,  rect.top))
      ||  el.contains(efp(rect.right, rect.top))
      ||  el.contains(efp(rect.right, rect.bottom))
      ||  el.contains(efp(rect.left,  rect.bottom))
    );
}


function dotsFunc(e) {
    const parent = e.target.closest('product-list')
    const items = parent.querySelectorAll(".desk-dots .slide-dots");
    let curSlide = 0;
    let maxSlide = items.length - 1;

    items.forEach( (el)=> {
        if ( el.classList.contains('active')) {
            el.classList.remove('active')
        }

        if ( e.target.classList.contains('prev-next-button--next') && el.dataset.index == 2) {
            el.classList.add('active')
        } else if ( e.target.classList.contains('prev-next-button--prev') && el.dataset.index == 1 ) {
            el.classList.add('active')
        }
    })
}

// const inViewObserver = new IntersectionObserver(entries => {

//     entries.forEach(entry => {

//         const parent = entry.target.closest('product-list');
//         const itemsMobile = parent.querySelectorAll(".phone-dots .slide-dots");

//         if (entry.isIntersecting) {
//             // do stuff when in view
//             var entryIndex = entry.target.dataset.index;

//             console.log(entryIndex)

            
//             itemsMobile.forEach( (el)=> {
//                 if ( el.classList.contains('active')) {
//                     el.classList.remove('active')
//                 }
        
//                 if ( el.dataset.index == entryIndex ) {
//                     el.classList.add('active')
//                 }
//             })

//         }
//     })
// }, { threshold: .5 })


// var productItems =  document.querySelectorAll('product-list .scroller product-item')

// productItems.forEach( e => {
//     inViewObserver.observe(e)
// })

var prevMobile = document.querySelectorAll('.prev-mobile')
var nextMobile = document.querySelectorAll('.next-mobile')

prevMobile.forEach((el)=> {
    el.addEventListener('click', function(e) {
        var parent = e.target.closest('product-list')
        var slider = parent.querySelector('.scroller')
        var item = parent.querySelectorAll('product-item');
        const distance = item[0].clientWidth;

        slider.scrollBy({
            left: -distance,
            behavior: 'smooth'
        });
    })
})


nextMobile.forEach( (el)=> {
    el.addEventListener('click', function(e) {
        var parent = e.target.closest('product-list')
        var slider = parent.querySelector('.scroller')
        var item = parent.querySelectorAll('product-item');
        const distance = item[0].clientWidth;

        slider.scrollBy({
            left: distance,
            behavior: 'smooth'
        });
    })
})




document.querySelectorAll('product-list .scroller').forEach( (e)=> {

    const parent = e.parentNode;
    const slides = e.querySelectorAll('product-item')
    const items = parent.querySelectorAll(".desk-dots .slide-dots");
    let curSlide = 0;
    let maxSlide = parseInt(slides.length / 6);


    document.addEventListener("prev-next:next", (e)=> {

        if (curSlide === maxSlide) {
            curSlide = 0;
        } else {
            curSlide++;
        }
    
        console.log(curSlide)

        items.forEach( (el)=> {
            if ( el.classList.contains('active')) {
                el.classList.remove('active')
            }
    
            if (el.dataset.index == curSlide ) {
                el.classList.add('active')
            }
        })
    })


    document.addEventListener("prev-next:prev", (e)=> {
        if (curSlide === 0) {
            curSlide = maxSlide;
        } else {
            curSlide--;
        }
    
        console.log(curSlide)

        items.forEach( (el)=> {
            if ( el.classList.contains('active')) {
                el.classList.remove('active')
            }
    
            if (el.dataset.index == curSlide ) {
                el.classList.add('active')
            }
        })
    })

})

window.addEventListener('DOMContentLoaded', (event) => {
    var collapse_buttons = Array.from(document.querySelectorAll('.product-tabs .tabs-nav__item-list .tabs-nav__item'))
    if ( typeof(collapse_buttons[0]) != undefined && collapse_buttons[0] != null ) {
        var width = screen.width;

        if (width >= 1000 ) {
            const event = new Event("click", {
                bubbles: true,
                cancelable: true
            });
    
            collapse_buttons[0].dispatchEvent(event);
            var id = collapse_buttons[0].getAttribute('aria-controls')
            var tabs = document.querySelector('.product-tabs__content')
            var firstTab = document.getElementById(id)
            firstTab.removeAttribute('hidden')
        }

    }

    dispatchEvent();
    document.documentElement.addEventListener('mr:cartTotalUpdate', ev => {
        if (ev.detail.isMonkDiscountApplicable) {
            const price = +ev.detail.price.toString()
            updateShippingBar(price)
            // updateCheckoutButtonPrice(price)
        }
    });
});


const priceFormatter = new Intl.NumberFormat('en-NL', {
    style: 'currency',
    currency: 'EUR',
});

const updateShippingBar = (price)=>{
    const shippingBar = document.querySelector('.shipping-bar');


    if (shippingBar) {
        // shippingBar.style.display = 'none'
        const threshold = +shippingBar?.getAttribute('threshold');
        const thresholdPrice = +parseFloat(threshold/100).toFixed(2);
        if (price < thresholdPrice) {
            const progressCalc = Math.min(parseFloat(price / thresholdPrice), 1);
            const shippingBarText = document.querySelector('.shipping-bar__text')
            const remainingPrice = +(+thresholdPrice - price).toString()

            const htmlString = `Besteed <span className="wh-original-cart-total"><span
                className="wh-original-price">${priceFormatter.format(remainingPrice).replace(',', '.')}</span></span><span className="wh-cart-total"></span><div
                className="additional-notes"><span className="wh-minimums-note"></span><span
                className="wh-extra-note"></span></div> of meer en ontvang gratis verzending!</span>`

            //originalPrice.innerText = priceFormatter.format(finalPrice).replace(',', '.');
            shippingBarText.innerHTML = htmlString;
            shippingBar.style.setProperty("--progress", progressCalc);
            // update checkout button price
        }
        shippingBar.style.display = 'block'
    }


}
const updateCheckoutButtonPrice = (price) => {
    const priceText = document.querySelector('.wh-original-price');
    priceText.innerText =  `${priceFormatter.format(price).replace(',', '.')}`
}

function dispatchEvent() {
    document.documentElement.dispatchEvent(new CustomEvent("cartState:change", {
        bubbles: true,
        detail: {}
    }));
}

// document.addEventListener('cart:updated', function (event) {
//     dispatchEvent();
// });
